import React from 'react';
import './style.css';
import HeaderInner from './components/HeaderBoxes'
import HeaderBoxes from './components/HeaderInner'
import AboutUs from './components/AboutUs'
import Schedule from './components/Schedule'
import Media from './components/Media'
import Locations from './components/Locations'
import Contact from './components/Contact'
import Sponsors from './components/Sponsors'
import FooterInner from './components/FooterInner'
import Nav from './components/Nav'



export class App extends React.PureComponent {
  render() {
    return ( 
 
  
      <div>
           
        <header  id="start">  
          <div className="head-img"></div>
          
          <div>
            <Nav className="TopBar"/>
            <HeaderInner/>
            <HeaderBoxes/>
          </div>
        </header>
  
        <main>
          <AboutUs/>
          <Schedule/>
          <Media/>
          <Locations/>
          <Contact/>
          <Sponsors/>
        </main>
        <footer  className="container-fluid">
          <FooterInner/>
          </footer>
      </div>
    );
  }
  }

export default App
